import { ContextStore, ExperimentStore, PageStore } from 'bernie-plugin-mobx';

export const getBucketValueByExperimentName = (experiment: ExperimentStore, experimentName: string) => {
  return experiment?.exposures?.[experimentName]?.bucket;
};

export const evaluateAndLogExperiment = (
  experiment: ExperimentStore,
  experimentName: string,
  context: ContextStore,
  page: PageStore
): number => {
  const experimentExposure = experiment?.exposures?.[experimentName];

  if (experimentExposure) {
    experiment.logExperiment(context, page, experimentExposure);
  }

  return getBucketValueByExperimentName(experiment, experimentName);
};
